module.exports = __webpack_public_path__ + "static/media/tired-regular.4df33cef.svg";